import {Cookies, DomHelper} from "../general/utils";

window.pu = window.pu || {};
window.pu = {
    parent: (top != self && typeof (top['document']['location'].toString()) === 'string') ? top : self,
    window: null,
    url: "/pu/",
    cookieNamespace: 'pu',
    cookieNameOpened: 'opened',
    cookieNameClosed: 'closed',
    cookieNameCap: 'cap',
    cookieName: 'name',
    cookieNameCount: 'count',
    cookieExpire: 0.0416,
    cookieNameValue: (Math['floor']((Math['random']() * 1000) + 1)),
    todayPops: 0,
    cap: 5000,
    options: 'toolbar=no,scrollbars=no,location=no,directories=no,locationbar=no,statusbar=no,menubar=no,resizable=no,width=850,height=864,screenX=' + window['screenX'] + ',screenY=' + window['screenY']
};

window.puconfig = window.puconfig || [];

class PopUnder {

    static initPopUnder () {
        document.querySelectorAll('#overflow-wrapper a').forEach(el=>{
          el.addEventListener("click",(e)=>{
            if(e.currentTarget.href){
              e.preventDefault()
              Cookies.set(PopUnder.getCookieName(window.pu.cookieNameCount), 2, window.pu.cookieExpire);
              if(!PopUnder.isRightClick(e) && DomHelper.getWindowInnerWidth() >= 1000) {
                PopUnder.showPopUnder();
              }
              window.location.href=e.currentTarget.href
            }
          })
        })

    }

    static isRightClick (event) {
        return event.which === 3;
    }

    static showPopUnder () {
        if(!Cookies.has(PopUnder.getCookieName(window.pu.cookieName))) {

            if(!PopUnder.isCapped()) {

                window["pop_clicked"] = 1;
                if (window.pu.parent && typeof window.pu.parent.window !== 'undefined') {
                    window.pu.window = window.pu.parent.window.open(window.pu.url, window.pu.cookieNameValue, window.pu.options);
                }

                if(window.pu.window) {
                    Cookies.set(PopUnder.getCookieName(''), 1, window.pu.cookieExpire);
                    Cookies.set(PopUnder.getCookieName(window.pu.cookieNameCap), (window.pu.todayPops + 1), window.pu.cookieExpire);
                    try {
                        window.pu.window['blur']();
                        window.pu.window['opener']['window']['focus']();
                        window['self']['window']['blur']();
                        window['focus']();
                    } catch(e) {}
                }

                Cookies.set(PopUnder.getCookieName(window.pu.cookieName), window.pu.cookieNameValue, window.pu.cookieExpire);
            }
        }
    }

    static getCookieName (name) {
        return window.pu.cookieNamespace + (name ? '-' + name : '');
    }

    static isCapped () {
        try {
            window.pu.todayPops = Math['floor'](document['cookie']['split'](PopUnder.getCookieName(window.pu.cookieNameCap) + '=')[1]['split'](';')[0]);
        } catch (err) {}
        return (window.pu.cap <= window.pu.todayPops || document['cookie']['indexOf'](PopUnder.getCookieName(window.pu.cookieNameCap) + '=') !== -1);
    }

    static close () {
        if(Cookies.has(PopUnder.getCookieName(window.pu.cookieName))) {
            if(Cookies.get(PopUnder.getCookieName(window.pu.cookieNameClosed), 0) != 1) {
                let puWindow = window.open('', Cookies.get(PopUnder.getCookieName(window.pu.cookieName)), 'status=1,width="350",height="150"');
                if (puWindow !== null && false === puWindow.closed) {
                    puWindow.close();
                    this.setClosed();
                }
            }
        }
    }

    static setClosed () {
        Cookies.set(PopUnder.getCookieName(window.pu.cookieNameClosed), 1, 0.0416);
    }
}

export {
    PopUnder
};
